module.exports = {
  "version": {
    "backend": "3.12.0-beta.1",
    "frontend": "3.12.0-beta.1"
  }
}